import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'react-tooltip/dist/react-tooltip.css';
import './assets/app/components/css/boostrapCustom.css';
import RoutesComponent from './RoutesComponent.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RoutesComponent/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
